import { Skeleton } from '@parsina/framework';

/**
 * The loading shapes for the money sheet — `MobileSettleSheet`.
 *
 * They live in the mobile library rather than in a screen's skeleton file for
 * two reasons. The first is the boundary: `src/mobile` is a LIBRARY, and a
 * library that imports a screen is no longer one (the `mobileBoundary` test
 * enforces exactly this, and these three were what it was failing on). The
 * second is the geometry rule — a skeleton is sized to the component it stands
 * for, so `MobileMoneyRowSkeleton` has to sit beside `MobileMoneyRow` if the
 * two are to be changed in the same commit (DESIGN.md §"Loading & skeleton" —
 * geometry).
 *
 * The settle sheet composes `MobileMoneyRowSkeleton` from
 * here; that direction — a screen reaching into the library — is the allowed
 * one.
 */

/** A `MobileMoneyRow` in placeholder: label on the start edge, figure on the end. */
export function MobileMoneyRowSkeleton({ strong = false }) {
  return (
    <div
      aria-hidden
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: '0.75rem', minHeight: '1.75rem',
      }}
    >
      <Skeleton width={strong ? 72 : 60} height={strong ? 13 : 12} />
      <Skeleton width={strong ? 96 : 80} height={strong ? 18 : 14} />
    </div>
  );
}


